import React from "react";
import { ImageComponent } from "./ImageComponent";
const ChipComponent = ({
  children,
  type,
  icon,
  className
}) => {
  className = className ? className : "";
  const getChipIcon = icon => {
    if (typeof icon === "string") {
      return /*#__PURE__*/React.createElement(ImageComponent, {
        src: icon
      });
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, icon);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${className}${getChipStyle(type)}`
  }, icon && getChipIcon(icon), children);
};
const getChipStyle = type => {
  switch (type) {
    case "primary":
      return " bg-purple-100 rounded-2xl px-2 py-0.5 font-medium text-purple-700 inline-flex items-center";
    case "tertiary":
      return " bg-gray-100 rounded-2xl px-2 py-0.5 font-medium text-gray-700 flex inline-flex items-center";
    case "success":
      return " bg-green-100 rounded-2xl px-2 py-0.5 font-medium text-green-700 flex inline-flex items-center";
    default:
      return "";
  }
};
export { ChipComponent };